import { jsonApiAxios } from '../api';

const relationshipToTypeMap = {
  category: 'dossierItemCategories',
};

const dossierItemSchema = {
  attributes: ['category', 'claim', 'file'],
  claim: {
    ref: 'id',
  },
  category: {
    ref: 'id',
  },
  file: {
    ref: 'id',
  },
  typeForAttribute: attribute => relationshipToTypeMap[attribute],
};

/**
 * Creates dossierItem entity and uploads file
 * @param file
 * @param relationship
 * @returns {Promise}
 */
export async function uploadFile({ file, relationship, config = {} }) {
  let formData = new FormData();
  formData.append('data[attributes][file]', file);
  formData.append('data[type]', 'files');

  const { headers, onUploadProgress } = config;

  const { id: fileId } = await jsonApiAxios.post('/files', formData, {
    noSerialize: true,
    ...config,
    onUploadProgress,
    headers: {
      'Content-Type': 'multipart/form-data',
      ...headers,
    },
  });

  const { id: dossierItemId } = await jsonApiAxios.post(
    '/dossierItems',
    {
      ...relationship,
      file: {
        id: fileId,
      },
    },
    {
      schema: dossierItemSchema,
      type: 'dossierItems',
      headers,
    }
  );

  return { fileId, dossierItemId };
}

export function deleteDossierItem({ dossierItemId, config }) {
  return jsonApiAxios.delete(`/dossierItems/${dossierItemId}`, config);
}
